import styled from "styled-components";
import { Typography } from "antd";

const { Title } = Typography;

export const StyledTitle = styled(Title)`
  margin-top: 0;
  padding-top: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
